// @core/api/endpoints/document/create_document_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDocumentPolicyRequest,
  DocumentPolicyResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create policy
 * Creates a document management policy for a scope entity (project, team, department, organization). Domain services call this to configure document rules for their entities.
 */
export async function CreateDocumentPolicy(
  data: CreateDocumentPolicyRequest,
  options?: RequestOptions
): Promise<DocumentPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-policies`;
  const requestOptions = options;
  return client.post<DocumentPolicyResponse>(requestPath, data, requestOptions);
}
